<template>
	<ContentSlider
		:content-id="'footer-some'"
		:slide-spacing="4"
		:slide-per-view="2"
		:slide-overflow="true"
		:slide-breakpoints="breakpoints"
		:slide-shadow="false"
		:slide-loop="true"
	>
		<template v-slot:heading>
			<h2 class="h1">{{ translations['Follow Surisuri'] }}</h2>
			<div v-if="language == 'SV'">
				<a v-if="url" :href="url">@surisuri.se</a>
				<p v-else>@surisuri.se</p>
			</div>
			<div v-else>
				<a v-if="url" :href="url">@surisuri.dk</a>
				<p v-else>@surisuri.dk</p>
			</div>
		</template>
		<template v-slot:slides>
			<SwiperSlide v-for="slide in feed.length ? feed : 5" :key="slide.index">
				<a :href="slide.permalink" class="slide" v-if="feed.length">
					<img :src="slide.imageUrl" :alt="slide.caption" />
				</a>
				<div class="slide slide--loading" v-else></div>
			</SwiperSlide>
		</template>
	</ContentSlider>
</template>

<script>
import axios from 'axios';
import ContentSlider from './ContentSlider.vue';
import { SwiperSlide } from 'swiper/vue';
import * as map from '@/vue/mixins/map';

export default {
	name: 'InstagramFeed',
	components: { ContentSlider, SwiperSlide },
	mixins: [map.site],
	props: {
		url: {
			type: String,
			default: '',
		},
	},
	data: () => {
		return {
			feed: [],
			isLoaded: false,
			breakpoints: {
				700: { slidesPerView: 3 },
				950: { slidesPerView: 4 },
				1400: { slidesPerView: 4.5 },
			},
		};
	},
	methods: {
		fetch: async function () {
			let tag = 'surisuri';

			if (this.language == 'SV') {
				tag = 'surisuri-se';
			}

			axios
				.get('https://api.socialfeeds.qnty.dk/feed/' + tag + '/instagram', {
					params: {
						//Reason for us limiting the posts to 16 later and limiting to 24 here is
						//? to ensure that we have enough posts that are type /p/ and not of type /reel/.
						//? /reel/ posts don't look as intended in the slider.
						limit: 16,
					},
				})
				.then((result) => {
					if (result.data) {
						//? Disabled
						// this.filterPosts(result.data.feed);

						this.feed = result.data.feed;

						this.isLoaded = true;
					}
				})
				.catch((error) => {});
		},
		filterPosts(feed) {
			let feedArray = [];

			for (let i = 0; i < feed.length; i++) {
				if (
					feed[i].permalink.includes('/p/') &&
					!feed[i].imageUrl.includes('/null')
				) {
					feedArray.push(feed[i]);
				}
			}

			// Limit the feed to 16 post.
			if (feedArray.length > 16) {
				feedArray = feedArray.slice(0, 16);
			}

			this.feed = feedArray;
		},
	},
	mounted() {
		this.fetch();
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';
</style>
